export const SET_ERROR = "setError";
export const ISLOADING = "isLoading";
export const SET_CURRENT_USER = "currentUser";
export const SET_AUTH_METHOD = "setAuthMethod";
export const SET_MSAL_ACCOUNT = "setMsalAccount";
export const SET_USER_PROFILE = "setUserProfile";
export const SET_IS_AUTHENTICATED = "setIsAuthenticated";
export const CLEAR_AUTH = "clearAuth";
